
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

import util from "./common/util";
Vue.prototype.util = util;

import tool from "./common/tool";
Vue.prototype.tool = tool;

import http from "./common/http";
Vue.prototype.http = http;

import global from "./common/global";
Vue.prototype.global = global;

import share from "./common/share";
Vue.prototype.share = share;

import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)

import VScrollLock from 'v-scroll-lock'
Vue.use(VScrollLock)

import { Toast,Dialog } from 'vant';
import 'vant/lib/toast/style';
import 'vant/lib/dialog/style';
Vue.use(Toast,Dialog);

router.beforeEach((to, from, next) => {
    if(to.fullPath.indexOf('jump_from') >= 0){
        const reg = /&jump_from.*/g;
        const fullPath = to.fullPath.replace(reg,'')
        next(fullPath)
    }else{
        if(to.meta.login){
            var access_token = util.getAccessToken();
            if(!access_token){
                next({
                    path: '/login',
                    query: {from: to.fullPath}
                })
            }else{
                next();
            }
        }else{
            next();
        }
    }
});


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
